import { Roles } from '../../models/roles'
import {
  ArticleScopeKeys,
  ArticleScopeLabelTranslationKeys,
  ArticleScopePathExclusions,
  ArticleScopePaths,
  ArticleScopeValues,
  ArticleShowBannerValue,
  ArticleTypeBorder,
  ArticleTypeKeys,
  ArticleTypeLabelTranslationKeys,
  ArticleTypeValues,
  DefaultArticleScopeValue,
  DefaultArticleTypeBorder,
  DefaultArticleTypeValue,
} from './constants'
import { Features, isEnabled } from '../../models/features'
import { getText } from '../../internal/TextLabels'

export const getTypeFromTags = tags =>
  Object.entries(ArticleTypeKeys).find(([key]) =>
    tags.includes(ArticleTypeValues[key]),
  )?.[0] || ArticleTypeKeys.INFO

export const getTypeFromTypeValue = value =>
  Object.entries(ArticleTypeKeys).find(
    ([key]) => ArticleTypeValues[key] === value,
  )?.[0] || ArticleTypeKeys.INFO

export const getTypeValueFromTags = tags =>
  (!!tags &&
    tags.find(tag =>
      Object.values(ArticleTypeValues).includes(tag.toLowerCase()),
    )) ||
  DefaultArticleTypeValue

export const getBorderType = tags => {
  if (tags) {
    const value = getTypeValueFromTags(tags)
    const [key] = Object.entries(ArticleTypeValues).find(
      ([_key, _value]) => !!ArticleTypeKeys[_key] && _value === value,
    )
    return !!key && ArticleTypeBorder[key]
  }
  return DefaultArticleTypeBorder
}

export const getScopeValueFromTags = tags =>
  !!tags &&
  tags.find(tag =>
    Object.values(ArticleScopeValues).includes(tag.toLowerCase()),
  )

export const isIncidentTypeAndResursAdmin = (type, role) =>
  type === ArticleTypeValues[ArticleTypeKeys.INCIDENT] &&
  role === Roles.RESURS_ADMIN

export const isIncidentType = type =>
  type === ArticleTypeValues[ArticleTypeKeys.INCIDENT]

export const isResursAdmin = role => role === Roles.RESURS_ADMIN

export const getTypeSelectValues = role =>
  Object.values(ArticleTypeKeys)
    .map(key => ({
      key,
      value: ArticleTypeValues[key],
      valueLabel: getText(ArticleTypeLabelTranslationKeys[key]),
    }))
    .filter(({ key }) =>
      key === ArticleTypeKeys.INCIDENT ? role === Roles.RESURS_ADMIN : true,
    )
    .filter(({ key }) =>
      key === ArticleTypeKeys.INCIDENT
        ? isEnabled(Features.INCIDENT_NOTIFICATION)
        : true,
    )

export const getSelectScopeValues = () =>
  Object.values(ArticleScopeKeys).map(key => ({
    key,
    value: ArticleScopeValues[key],
    valueLabel: getText(ArticleScopeLabelTranslationKeys[key]),
  }))

export const shouldShowArticleNotification = (tags, path) => {
  if (tags && tags.includes(ArticleShowBannerValue)) {
    const scopeValue = getScopeValueFromTags(tags) || DefaultArticleScopeValue

    const [scopeKey] = Object.entries(ArticleScopeValues).find(
      ([key, value]) => !!ArticleScopeKeys[key] && value === scopeValue,
    ) || [ArticleScopeKeys.GENERAL]

    return (
      ArticleScopePaths[scopeKey] &&
      new RegExp(ArticleScopePaths[scopeKey]).test(path) &&
      !ArticleScopePathExclusions.find(regex => new RegExp(regex).test(path))
    )
  }
  return false
}

export const getArticleBannerTag = tags =>
  (!!tags && tags.find(tag => tag === ArticleShowBannerValue)) || null
